/** The web callables answer a duplicate active project name with already-exists / project_name_taken. */
export function isProjectNameTaken(error: unknown): boolean {
  return error instanceof Error && error.message.includes("project_name_taken");
}
